import { ReactNode } from 'react';

export type ExpandableContentProps = {
  animationDuration?: number;
  expanded?: boolean;
  children: ReactNode;
  type?: AnimationType;
};

export enum AnimationType {
  Opacity,
  OpacityAndHeight,
}
